import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import ReactGA from 'react-ga4';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Navbar = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
  }, [location]);

  return (
    <nav className="navbar navbar-expand fixed-top navbar-dark bg-warning shadow-sm">
      <div className="container-fluid">
        <Link to="/" className="navbar-brand">
          <img src="/favicon-32x32.png" title="https://www.healthdash.lv" alt="HealthDash Logo" className="d-inline-block align-top" />
        </Link>
        <div className="collapse navbar-collapse" id="navbarsExample02">
          <ul className="navbar-nav ms-auto align-items-center">
            <li className="nav-item me-3">
              <a 
                className="nav-link text-white bg-dark rounded-pill px-3 py-1 font-weight-bold shadow-sm" 
                href="https://play.google.com/store/apps/details?id=com.linardsl.libhacontimig.hm.final" 
                target="_blank" 
                rel="noopener noreferrer" 
                style={{ fontSize: "0.85rem" }}
              >
                <FontAwesomeIcon icon="mobile-alt" className="me-1" />
                Install Android App
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/partners">Partners</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/favourite">Favourite</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/user">Dashboard</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
